export default "__VITE_ASSET__DOipzIY$__"